export default "__VITE_ASSET__BzjuiQGZ__"